import React, { useRef } from 'react'
import InsuranceListViewCard from './InsuranceListViewCard'
import { BodyLayout } from '../../Components'
import { Box, TablePagination, Typography } from '@mui/material'
import { BASE_URL } from '../../Utils/response'
import { getUserToken } from '../../Utils/LoginAuth'
import { useEffect, useState } from 'react'
import axios from 'axios'
import { useParams } from 'react-router-dom'

const InsuranceList = () => {
    const getHeader = () => {
        return {
            Authorization: 'Bearer ' + getUserToken(),
            'content-type': 'multipart/form-data',
        }
    }
    const [orders, setOrders] = useState([])
    const [loading, setLoading] = useState(false)
    const apiRef = useRef(null)
    const { status } = useParams()

    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)

    const filteredOrders =
        orders.records?.filter(
            (order) =>
                order?.requested_from_user?.city_id ===
                    order?.requested_by_user?.city_id &&
                order?.verification_order_details?.length <= 25
        ) || []

    const paginatedOrders = filteredOrders.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    )

    const handlePageChange = (event, newPage) => {
        setPage(newPage)
    }

    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10))
        setPage(0)
    }

    useEffect(() => {
        // if (!apiRef.current) {
        setLoading(true)
        apiRef.current = true
        axios
            .get(`${BASE_URL}/user-verifications-orders?status=${status}`, {
                headers: getHeader(),
            })
            .then((response) => {
                setOrders(response.data.data)
            })
            .finally(() => {
                setLoading(false)
            })
        // }
    }, [status])
    return (
        <div
            style={{
                backgroundColor: '#f1f5f9',
            }}
        >
            <BodyLayout sideBar={false}>
                {!loading ? (
                    <>
                        <section
                            style={{
                                marginTop: '20px',
                            }}
                        >
                            <Box
                                sx={{
                                    width: '90%',
                                    margin: 'auto',
                                    borderRadius: '10px',
                                    overflow: 'hidden',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 1,
                                }}
                            >
                                {paginatedOrders.map((order) => (
                                    <InsuranceListViewCard
                                        key={order.id}
                                        order={order}
                                    />
                                ))}
                            </Box>
                            {filteredOrders.length > 0 && (
                                <TablePagination
                                    component="div"
                                    count={filteredOrders.length}
                                    page={page}
                                    onPageChange={handlePageChange}
                                    rowsPerPage={rowsPerPage}
                                    onRowsPerPageChange={
                                        handleRowsPerPageChange
                                    }
                                    rowsPerPageOptions={[5, 10, 25, 50]}
                                    className="!mr-20"
                                />
                            )}
                        </section>
                        <section>
                            {filteredOrders?.length <= 0 && (
                                <Box
                                    sx={{
                                        width: '100%',
                                        backgroundColor: '#f1f5f9',
                                        marginTop: '20px',
                                    }}
                                >
                                    <Typography
                                        fontSize="16px"
                                        sx={{
                                            color: 'var(--black)',
                                            fontWeight: 'bold',
                                        }}
                                    >
                                        No orders right now
                                    </Typography>
                                </Box>
                            )}
                        </section>
                    </>
                ) : (
                    <div className="h-full w-full flex justify-center items-center">
                        <div className="h-10 aspect-square border-4 border-r-blue-600 rounded-full animate-spin"></div>
                    </div>
                )}
            </BodyLayout>
        </div>
    )
}

export default InsuranceList
